
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/series/list/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/series/list/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/series/list/[[...pathParams]]"])
      });
    }
  